import type { GuardAsync } from "vike/types";
import { redirect } from "vike/abort";
import { EntriesClient } from "~/api/entries";
import { ApiClientError } from "~/api/apiClient";
import { routes } from "~/routes";
import { localeAware } from "~/utils/localeAware";

export const guard: GuardAsync = async (
  pageContext
): ReturnType<GuardAsync> => {
  const entriesClient = useApiClient(EntriesClient, pageContext);
  const activeEntrySlug = pageContext.routeParams.activeEntrySlug;
  const { workspace } = routes;
  const { withLocale } = localeAware(pageContext);
  // make sure we have the canonical URL
  if (activeEntrySlug) {
    try {
      const { canonical_path, curated } =
        await entriesClient.fetchSchemaBySlug(activeEntrySlug);
      const { legalTextSlug, legalTextParagraphSlug } = pageContext.routeParams;

      if (
        curated &&
        canonical_path !==
          `${workspace}/${legalTextSlug}/${legalTextParagraphSlug}`
      ) {
        throw redirect(withLocale(`${canonical_path}/${activeEntrySlug}`), 301);
      }
    } catch (e) {
      console.error("Error while fetching schema", e);
      if (e instanceof ApiClientError) {
        const url = e.request?.url;
        console.error(`Error message: ${e.message} for URL: ${url}`);
      } else {
        throw e;
      }
    }
  }
};
